export const quotesTickersRoutes = { tickerDetails: { proxy: 'quotes/tickers', upstream: 'v3/tickerDetail' } } as const;
